import type { StrictOmit } from '@enmon/commons';
import type { CustomerEmissionFactor } from '@enmon/commons/lib/enmon';
import type { IntlShape, MessageDescriptor } from 'react-intl';
import type { EmissionFactor } from '@enmon/commons/lib/tools';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from '../root';

type TranslatedEmissionFactorKeys = keyof StrictOmit<
  CustomerEmissionFactor,
  '_id' | 'customer' | 'createdAt' | 'updatedAt'
>;

export const EMISSION_FACTOR_FIELDS_TRANSLATED = defineMessages<TranslatedEmissionFactorKeys>({
  name: APP_DICTIONARY.name,
  baseUnit: APP_DICTIONARY.unit,
  emissionFactorCategories: { id: 'app.common.emissionCategory.title.singular' },
  externalId: { id: 'app.emissions.factor.field.externalId' },
});

const emissionFactorNameMessage = (emissionFactorId: EmissionFactor['id'] | string) =>
  defineMessages({
    name: {
      id: `app.emissions.factor.${emissionFactorId}`,
    },
  });

export function getEmissionFactorMessage(emissionFactorId: EmissionFactor['id'] | string): MessageDescriptor {
  return emissionFactorNameMessage(emissionFactorId).name;
}

export function getTranslatedEmissionFactor(emissionFactorId: EmissionFactor['id'] | string, intl: IntlShape): string {
  return intl.formatMessage(getEmissionFactorMessage(emissionFactorId));
}
